import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import "./TeamDetails.css";
import male from "../Images/male.png";
import female from "../Images/female.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookSquare,
  faYoutube,
  faInstagramSquare,
  faTwitterSquare,
} from "@fortawesome/free-brands-svg-icons";
import {
  faHistory,
  faFlag,
  faFutbol,
  faMars,
} from "@fortawesome/free-solid-svg-icons";

const TeamDetails = () => {
  const { teamID } = useParams();
  const [team, setTeam] = useState([]);
  console.log(team);
  useEffect(() => {
    const url = `https://www.thesportsdb.com/api/v1/json/1/lookupteam.php?id=${teamID}`;
    fetch(url)
      .then((res) => res.json())
      .then((data) => setTeam(data.teams[0]));
  }, [teamID]);
  const {
    intFormedYear,
    strGender,
    strSport,
    strCountry,
    strTeamBadge,
    strDescriptionEN,
    strStadiumDescription,
    strTeam,
    strFacebook,
    strInstagram,
    strYoutube,
    strTwitter,
    strStadiumThumb
  } = team;
  let image = "";
  if (strGender === "Male") {
    image = male;
  } else {
    image = female;
  }
  const headerBG ={
    backgroundImage:`url(${strStadiumThumb})`,
    backgroundRepeat:'no-repeat',
    backgroundPosition:'center',
    backgroundSize:'100%'
  }

  return (
    <div className="body">
      <div style={headerBG} className="header d-flex align-items-center justify-content-center">
        <img src={strTeamBadge} alt="" />
      </div>
      <div className="team-details container">
        <div className="team-info order-first col-lg-6 ">
          <h1>{strTeam}</h1>
          <p>
            <FontAwesomeIcon icon={faHistory} /> Founded: {intFormedYear}
          </p>
          <p>
            <FontAwesomeIcon icon={faFlag} /> Country: {strCountry}
          </p>
          <p>
            <FontAwesomeIcon icon={faFutbol} /> Sport Type: {strSport}
          </p>
          <p>
            <FontAwesomeIcon icon={faMars} /> Gender: {strGender}
          </p>
        </div>
        <div className="player-img col-lg-6 ">
          <img src={image} alt="" />
        </div>
      </div>
      <div className="container">
        <div>
          <p>{strDescriptionEN}</p>
          <br />
          <br />
          <br />
          <p>{strStadiumDescription}</p>
        </div>
      </div>
      <div className="fIcon ">
        <ul className="d-flex align-items-center justify-content-center">
          <a href={`https://${strFacebook}`} target="_blank" rel="noreferrer">
            <li>
              {" "}
              <FontAwesomeIcon icon={faFacebookSquare} size="2x" />
            </li>
          </a>
          <a href={`https://${strYoutube}`} target="_blank" rel="noreferrer">
            <li>
              <FontAwesomeIcon icon={faYoutube} size="2x" />{" "}
            </li>
          </a>
          <a href={`https://${strInstagram}`} target="_blank" rel="noreferrer">
            <li>
              <FontAwesomeIcon icon={faInstagramSquare} size="2x" />{" "}
            </li>
          </a>
          <a href={`https://${strTwitter}`} target="_blank" rel="noreferrer">
            <li>
              <FontAwesomeIcon icon={faTwitterSquare} size="2x" />{" "}
            </li>
          </a>
        </ul>
      </div>
    </div>
  );
};

export default TeamDetails;
